function defineMiddleware(fn) {
  return fn;
}
export {
  defineMiddleware
};
